import { useCallback, useContext } from 'react'

import { TPriceRespApiDto } from 'nexchange-service/module/coins'
import { ShowWarningAction, WarningContext } from 'nexchange-service/module/common'

import {
    AvailableCurrenciesContext,
    mapApiPairDtoToCoinDtos,
    SelectedCoinsContext,
    SetSelectedPairAction,
} from '../../stateManagement'
import { auditPairInputDtos, getClampUptoRangeAmount } from '../../utils'

const useOnGetPairSuccessHandler = () => {
    const { dispatchAction: dispatchWarningAction } = useContext(WarningContext)
    const { dispatchAction: dispatchSelectedCoins } = useContext(SelectedCoinsContext)
    const {
        state: { currencies },
    } = useContext(AvailableCurrenciesContext)

    return useCallback(
        (apiPairDto: TPriceRespApiDto) => {
            const { fromCoinInputDto, toCoinInputDto } = mapApiPairDtoToCoinDtos({
                apiPairDto,
                availableCurrencies: currencies,
            })

            const roundedFromAmount = getClampUptoRangeAmount(fromCoinInputDto.amount, true)
            const roundedToAmount = getClampUptoRangeAmount(toCoinInputDto.amount, true)

            const updatedFromDto = { ...fromCoinInputDto, amount: roundedFromAmount }
            const updatedToDto = { ...toCoinInputDto, amount: roundedToAmount }

            const { errorMessage } = auditPairInputDtos({
                fromCoinInputDto: updatedFromDto,
                toCoinInputDto: updatedToDto,
            })

            if (errorMessage) {
                dispatchWarningAction(new ShowWarningAction(errorMessage))
            }

            // 2. update selected pair data:
            dispatchSelectedCoins(
                new SetSelectedPairAction({
                    availableCurrencies: currencies,
                    from: updatedFromDto,
                    to: updatedToDto,
                }),
            )
        },
        [currencies, dispatchSelectedCoins, dispatchWarningAction],
    )
}

export { useOnGetPairSuccessHandler }
